import type { CreditBalance, CreditPack } from '../types/domain';

export const INITIAL_PUBLISHER_CREDIT_BALANCE: CreditBalance = {
  total: 10,
  used: 0,
  reserved: 0,
  unlimited: false,
};

export const PUBLISHER_CREDIT_PACKS: CreditPack[] = [
  { id: 'pub5', credits: 5, price: 29, per: '5.80' },
  { id: 'pub10', credits: 10, price: 49, per: '4.90' },
  { id: 'pub25', credits: 25, price: 99, per: '3.96' },
  { id: 'pub50', credits: 50, price: 179, per: '3.58', best: true },
];
